/* Epic — performance bar reveal.

   Deliberately opt-in: the stylesheet only collapses the bars once this file
   has set [data-anim]. If the script never loads, never parses, or the browser
   lacks IntersectionObserver, the bars are simply already drawn. An animation
   that fails closed to "empty chart" would hide the strongest numbers Epic has.

   Re-runs on section:load so the theme editor redraws when a merchant edits
   the block. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

  function init(root) {
    var sections = (root || document).querySelectorAll('[data-epic-perf]');

    Array.prototype.forEach.call(sections, function (section) {
      if (section.hasAttribute('data-anim')) return;

      /* Stagger each bar by its position so the row order reads as a sweep
         rather than everything firing at once. */
      var rows = section.querySelectorAll('.epic-perf__row');
      Array.prototype.forEach.call(rows, function (row, i) {
        row.style.setProperty('--epic-i', i);
      });

      section.setAttribute('data-anim', '');

      /* Already on screen at load (short pages, deep links, the editor):
         paint immediately rather than waiting for a scroll that never comes. */
      var box = section.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        section.classList.add('is-in');
      } else {
        observer.observe(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
